import { useNavigate } from "react-router-dom";
import useStore from "@/zustand/store";
import { useState } from "react";

export function useLogout() {
  const navigate = useNavigate();
  const logout = useStore((state) => state.logout);
  const [open, setOpen] = useState(false);

  const handleLogout = () => setOpen(true);

  const confirmLogout = () => {
    logout(); // Perform the logout action
    navigate("/"); // Redirect to the home page
    window.location.reload(); // Refresh the page
    setOpen(false);
  };

  return {
    open,
    setOpen,
    handleLogout,
    confirmLogout,
  };
}
